import { useDurationRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { SubscriptionCommonInfoModel } from "../../entities/subscription";
import { Descriptions } from "antd";
import { useGetDurationsCommonInfoQuery } from "../../features/accounting/packageAPi";

export { useDurationRoutes };

export default GetDefaultIndex({
  title: "دوره‌ها",
  query: useGetDurationsCommonInfoQuery,
  generalInfoPresentor: (info: SubscriptionCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="تعداد فعال" labelStyle={{ color: "gray" }}>
          {info.activeRecords}
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
